__turbopack_context__.v({
  "aside": "search-layout-module-scss-module__AlQY3G__aside",
  "asideStickyContainer": "search-layout-module-scss-module__AlQY3G__asideStickyContainer",
  "buttonWrapper": "search-layout-module-scss-module__AlQY3G__buttonWrapper",
  "closeButton": "search-layout-module-scss-module__AlQY3G__closeButton",
  "contentSplit": "search-layout-module-scss-module__AlQY3G__contentSplit",
  "filtersButton": "search-layout-module-scss-module__AlQY3G__filtersButton",
  "fixedAside": "search-layout-module-scss-module__AlQY3G__fixedAside",
  "inverted": "search-layout-module-scss-module__AlQY3G__inverted",
  "main": "search-layout-module-scss-module__AlQY3G__main",
  "open": "search-layout-module-scss-module__AlQY3G__open",
  "title": "search-layout-module-scss-module__AlQY3G__title",
});
